var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 3.06445V14.2507H27.9363C27.3488 8.35445 22.6463 3.65195 16.75 3.06445ZM22.9613 25.5057C25.6975 23.4595 27.5788 20.3307 27.9363 16.7507H17.7075L22.9613 25.5057Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 15.5007V3.06445C7.9425 3.69445 3 9.0307 3 15.5007C3 22.3932 8.6075 28.0007 15.5 28.0007C17.3403 27.9983 19.1571 27.5867 20.8187 26.7957C20.8187 26.7957 14.2525 15.652 14.2513 15.507C14.2511 15.5048 14.2507 15.5027 14.25 15.5007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.7f03b86c0a054e3e0177f7012c926ad8.svg";
export { ForwardRef as ReactComponent };